<header id="header" class="fixed-top">
    <div class="container d-flex align-items-center justify-content-between">

        <nav id="navbar" class="navbar">

            <div class="pad_right_80">
                <h1 class="logo"><a href="index.html" style="margin-left: 0px !important;"><img
                            src="assets/img/logo.svg"></a></h1>
            </div>

            <a class="toggle-button">
                <span class="bar_line"></span>
                <span class="bar_line"></span>
                <span class="bar_line"></span>
            </a>


            <div class="navbar-links">
                <ul>
                    <li><a class="nav-link scrollto cursor_pointer" (click)="redirecttoHome()">Home</a></li>
                    <li><a class="nav-link scrollto cursor_pointer" href="Services.html">Services<i
                                class="fas fa-caret-down arrow_style" style="font-size: 15px; margin-top: 3px;"></i></a>


                        <div class="dropdown__menu">

                            <ul class="dpdwn_resp">
                                <li>
                                    <div class="services_dp_d border_bottom bg_clr_block_with_radius">
                                        <a (click)="navigatelevelmonitoring()" class="cursor_pointer dropdown_text"><img
                                                src="assets/images/service_vector1_b.svg" alt="" class="pad_right_img">
                                            <img src="assets/images/service_vector1.svg" alt="" class="pad_right_img">
                                            Level Monitoring System</a>
                                    </div>

                                </li>
                                <li>
                                    <div class="services_dp_d border_bottom bg_clr_block">
                                        <a (click)="redirecttoHome()" class="cursor_pointer dropdown_text"><img
                                                src="assets/images/service_vector2.svg" alt="" class="pad_right_img">
                                            <img src="assets/images/service_vector2_w.svg" alt="" class="pad_right_img">
                                            IIOT Software Platform</a>
                                    </div>

                                </li>
                                <li>
                                    <div class="services_dp_d border_bottom bg_clr_block">
                                        <a (click)="navigateenergymonitoring()"
                                            class="cursor_pointer dropdown_text"><img
                                                src="assets/images/Energy Monitoring System.svg" alt=""
                                                class="pad_right_img">
                                            <img src="assets/images/Energy Monitoring System_White.svg" alt=""
                                                class="pad_right_img">
                                            Energy Monitoring System</a>
                                    </div>

                                </li>
                                <li>
                                    <div class="services_dp_d border_bottom bg_clr_block">
                                        <a (click)="navigatepredictivemaitainance()"
                                            class="cursor_pointer dropdown_text"><img
                                                src="assets/images/service_vector3.svg" alt="" class="pad_right_img">
                                            <img src="assets/images/service_vector3_w.svg" alt="" class="pad_right_img">
                                            Predictive Maintenance System</a>
                                    </div>

                                </li>
                                <li>
                                    <div class="services_dp_d border_bottom bg_clr_block">
                                        <a (click)="redirecttoHome()" class="cursor_pointer dropdown_text"><img
                                                src="assets/images/service_vector4.svg" alt="" class="pad_right_img">
                                            <img src="assets/images/service_vector4_w.svg" alt="" class="pad_right_img">
                                            Wireless 4g Data Logger System</a>
                                    </div>

                                </li>
                                <li>
                                    <div class="services_dp_d border_bottom bg_clr_block">
                                        <a (click)="navigateflowmonitoring()" class="cursor_pointer dropdown_text"><img
                                                src="assets/images/service_vector5.svg" alt="" class="pad_right_img">
                                            <img src="assets/images/service_vector5_w.svg" alt="" class="pad_right_img">
                                            Flow Monitoring System</a>
                                    </div>

                                </li>
                                <li>
                                    <div class="services_dp_d bg_clr_block_with_d_radius">
                                        <a (click)="redirecttoHome()" class="cursor_pointer dropdown_text"><img
                                                src="assets/images/service_vector6.svg" alt="" class="pad_right_img">
                                            <img src="assets/images/service_vector6_w.svg" alt="" class="pad_right_img">
                                            Take Data-Driven Decision</a>
                                    </div>

                                </li>

                            </ul>


                        </div>


                    </li>
                    <li><a class="nav-link scrollto cursor_pointer" (click)="navigateabout()">About</a></li>


                    <li><a class="nav-link scrollto cursor_pointer" (click)="navigateblog()">Blog</a></li>
                    <li><a class="getstarted scrollto cursor_pointer" href="https://www.samyak.com/contact-us/">Contact</a></li>
                </ul>
            </div>

            <div class="dropdown show dpdw_show">
                <a class="btn btn-secondary dropdown-toggle" href="#" role="button" id="dropdownMenuLink"
                    data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                    Dropdown link
                </a>

                <div class="dropdown-menu" aria-labelledby="dropdownMenuLink">
                    <a class="dropdown-item" href="#">Action</a>
                    <a class="dropdown-item" href="#">Another action</a>
                    <a class="dropdown-item" href="#">Something else here</a>
                </div>
            </div>





        </nav>


    </div>
</header>